import React from "react";
import Chart from "react-apexcharts";

const monthNames = [
  "JANUARY",
  "FEBRUARY",
  "MARCH",
  "APRIL",
  "MAY",
  "JUNE",
  "JULY",
  "AUGUST",
  "SEPTEMBER",
  "OCTOBER",
  "NOVEMBER",
  "DECEMBER",
];

const colorPalette = [
  "#E9EDF5",
  "#9932CC",
  "#c29bd6",
  "#d81694",
  "#1E90FF",
  "#FF4500",
  "#32CD32",
  "#FFD700",
  "#DC143C",
  "#00BFFF",
];

function DoubleBarChart({ data = [] }) {
  const safeData = Array.isArray(data) ? data : [];

  const discoNames = Array.from(
    new Set(
      safeData.flatMap(
        (monthData) =>
          monthData?.discoData?.map((disco) => disco.discoName) || []
      )
    )
  );

  const discoColorMap = discoNames.reduce((acc, discoName, index) => {
    acc[discoName] = colorPalette[index % colorPalette.length];
    return acc;
  }, {});

  let series = [];
  if (safeData.length > 0) {
    series = safeData
      .map((monthData) => {
        const { discoData, month } = monthData || {};

        if (Array.isArray(discoData)) {
          return discoData.map((disco) => ({
            name: disco.discoName,
            type: "column",
            data: Array(12)
              .fill(0)
              .map((_, index) =>
                month === monthNames[index] ? disco.totalRevenue || 0 : 0
              ),
          }));
        }
        return [];
      })
      .flat();
  }

  if (series.length === 0) {
    return (
      <div className="flex items-center justify-center h-[290px] text-[12px] text-route-noncolor">
        No revenue data available
      </div>
    );
  }

  const seriesColors = series.map(
    (seriesItem) => discoColorMap[seriesItem.name]
  );

  const options = {
    colors: seriesColors,
    chart: {
      height: 220,
      type: "bar",
      toolbar: {
        show: false,
      },
    },
    grid: {
      show: false,
    },
    plotOptions: {
      bar: {
        horizontal: false,
        columnWidth: "45%",
        borderRadius: 1,
      },
    },
    dataLabels: {
      enabled: false,
    },
    stroke: {
      show: true,
      width: 2,
      colors: ["transparent"],
    },
    xaxis: {
      categories: [
        "Jan",
        "Feb",
        "Mar",
        "Apr",
        "May",
        "Jun",
        "Jul",
        "Aug",
        "Sep",
        "Oct",
        "Nov",
        "Dec",
      ],
    },
    yaxis: {
      tickAmount: 10,
      min: 0,
      max: 20000000,
    },
    fill: {
      opacity: 1,
    },
    legend: {
      show: false,
    },
  };

  return <Chart options={options} series={series} type="bar" height={290} />;
}

export default DoubleBarChart;
